/**
 * The free notes of each meetup bar check themselves: each tick draws once the bar is on screen
 * (modules/motion/once.js). The bar's pending state holds the ticks undrawn until then.
 */
import {EASING_CURVES} from '../modules/motion/easing.js';
import {playOnce} from '../modules/motion/once.js';

const SELECTOR = Object.freeze({
    bar: '.js-meetupBar',
    tick: '.js-meetupBarTick path',
});

/** The undrawn tick: the markup's pending offset, past the start of the one-unit path. */
const UNDRAWN = 1.1;

/** Milliseconds. */
const TICK = Object.freeze({leadIn: 150, stagger: 120, duration: 450});

/** @param {HTMLElement} bar */
function drawTicks(bar) {
    playOnce(bar, (run) => {
        bar.querySelectorAll(SELECTOR.tick).forEach((tick, index) => {
            run.add(tick.animate([{strokeDashoffset: UNDRAWN}, {strokeDashoffset: 0}], {
                delay: TICK.leadIn + index * TICK.stagger,
                duration: TICK.duration,
                easing: EASING_CURVES['ease-out-quint'],
                fill: 'backwards',
            }));
        });
    });
}

/** Draws the ticks of every meetup bar on the page. */
function init() {
    document.querySelectorAll(SELECTOR.bar).forEach((bar) => {
        if (bar instanceof HTMLElement) {
            drawTicks(bar);
        }
    });
}

document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
